<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractServiceEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="contract"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <ItpText
          strong
          :text="'Service'|pgettext('ContractServiceEditor')"
        >
        </ItpText>
        <ItpFormGroup
          name="service"
          :label="'Service'|pgettext('ContractService')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          :helpTooltip="'Select the product or service the invoice line refers to.'|pgettext('ContractService|Tooltip')"
          required
        >
          <ItpFormSelect2
            name="client"
            v-model="item.service"
            bind-object
            :options="services"
            textField="name"
            :readonly="isServiceReadonly"
            @optionSelected="evh_3054425420812800_optionSelected($event, {})"
          >
          </ItpFormSelect2>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="3"
          contentColsMd="9"
          name="invoice_group_id"
          :label="'Invoice Group'|pgettext('ContractService')"
          :labelAlign="labelAlign"
          :helpTooltip="'The invoice group this service belongs to.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormSelect2
            name="invoice_group_id"
            v-model="item.invoice_group_id"
            :multiple="b_7307096920626688_multiple"
            :options="invoiceGroups"
            valueField="id"
            textField="name"
            clearable
            :readonly="isServiceReadonly"
          >
          </ItpFormSelect2>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="3"
          name="intermediated_service"
          :label="'Intermediated service'|pgettext('ContractService')"
          :labelAlign="labelAlign"
          :helpTooltip="'Select this option if the service is provided via an intermediary party.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormCheckbox
            name="intermediated_service"
            v-model="item.intermediated_service"
            :readonly="isServiceReadonly"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          name="valid_from"
          :label="'Valid from'|pgettext('ContractService')"
          labelColsMd="3"
          contentColsMd="4"
          :labelAlign="labelAlign"
          :helpTooltip="'Specifies the start date of the service period.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormDatetime
            name="valid_from"
            v-model="item.valid_from"
            required
            :readonly="isServiceReadonly"
          >
          </ItpFormDatetime>
        </ItpFormGroup>
        <ItpFormGroup
          name="valid_to"
          :label="'Valid to'|pgettext('ContractService')"
          labelColsMd="3"
          contentColsMd="4"
          :labelAlign="labelAlign"
          :helpTooltip="'The service end date. Set only if it\'s different from the contract\'s end date.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormDatetime
            name="valid_to"
            v-model="item.valid_to"
            :readonly="isServiceReadonly"
          >
          </ItpFormDatetime>
        </ItpFormGroup>
        <ItpFormGroup
          name="valid_to"
          :label="'Description'|pgettext('ContractService')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          :helpTooltip="'Internal notes for reference only. Not visible externally.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormTextarea
            name="description"
            v-model="item.description"
            :readonly="isServiceReadonly"
            rows="5"
          >
          </ItpFormTextarea>
        </ItpFormGroup>
        <hr>
        </hr>
        <fieldset>
          <legend>
            {{ 'Invoicing'|pgettext('ContractServiceEditor|Section') }}
          </legend>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="6"
            name="billing_category"
            :label="'Billing category'|pgettext('ContractService')"
            :labelAlign="labelAlign"
            :helpTooltip="'The invoice category this service should be assigned to when billed. New values entered will be saved for future use.'|pgettext('ContractService|Help|BillingCategory')"
          >
            <ItpFormSelect2
              name="billing_category"
              taggable
              :options="billingCategories"
              v-model="item.billing_category"
              :readonly="item.isReadonly"
              valueField="name"
              textField="name"
            >
            </ItpFormSelect2>
          </ItpFormGroup>
          <ItpFormGroup
            name="name"
            :label="'Name'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'This text will appear on the invice line.'|pgettext('ContractService|Tooltip')"
            required
          >
            <ItpFormInput
              name="name"
              v-model="item.name"
              required
              :readonly="isServiceReadonly"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            name="name"
            :label="'Name(s)'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'This text will appear on the invice line.'|pgettext('ContractService|Tooltip')"
            required
          >
            <UCContractServiceItemNameEditor
              v-model="item.invoice_item_name"
              :readonly="isServiceReadonly"
            >
            </UCContractServiceItemNameEditor>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
          >
            <hr
              class="dots"
            >
            </hr>
          </ItpFormGroup>
          <ItpFormGroup
            name="invoice_notes"
            :label="'Invoice notes'|pgettext('ContractServiceFee')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'Note to display on the invoice line.'|pgettext('ContractService|Tooltip')"
          >
            <ItpFormTextarea
              name="fee_notes"
              v-model="item.invoice_notes"
              :readonly="isServiceReadonly"
            >
            </ItpFormTextarea>
          </ItpFormGroup>
          <ItpFormGroup
            name="transaction_notes"
            :label="'Additional invoice notes'|pgettext('ContractServiceFee')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'Note to display on the invoice line conditionally.'|pgettext('ContractService|Tooltip')"
          >
            <TransactionNotesEditor
              v-model="item.transaction_notes"
              :readonly="isServiceReadonly"
            >
            </TransactionNotesEditor>
          </ItpFormGroup>
          <ItpFormGroup
            name="billing_frequency"
            :label="'Billing frequency'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="3"
            :labelAlign="labelAlign"
            :helpTooltip="'The cycle length of issuing the invoices.'|pgettext('ContractService|Tooltip')"
          >
            <BillingFrequencySelector
              v-model="item.billing_frequency"
              :readonly="isServiceReadonly"
            >
            </BillingFrequencySelector>
          </ItpFormGroup>
          <ItpFormGroup
            name="billing_date_rule"
            :label="'Billing date rule'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'The cycle length of issuing the invoices.'|pgettext('ContractService|Tooltip')"
          >
            <BillingDateRuleFields
              v-model="item.billing_date_rule"
              :readonly="isServiceReadonly"
            >
            </BillingDateRuleFields>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
          >
            <hr
              class="dots"
            >
            </hr>
          </ItpFormGroup>
          <ItpFormGroup
            name="due_date_rule"
            :label="'Due date rule'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'The rule of calculating the payment dates.'|pgettext('ContractService|Tooltip')"
          >
            <DueDateRuleFields
              v-model="item.due_date_rule"
              :readonly="isServiceReadonly"
            >
            </DueDateRuleFields>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
          >
            <hr
              class="dots"
            >
            </hr>
          </ItpFormGroup>
          <ItpFormGroup
            name="billing_currency"
            :label="'Billing currency'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="3"
            :labelAlign="labelAlign"
            :helpTooltip="'The currency to use on the invoice.'|pgettext('ContractService|Tooltip')"
          >
            <BillingCurrencySelector
              v-model="item.billing_currency"
              :readonly="isServiceReadonly"
            >
            </BillingCurrencySelector>
          </ItpFormGroup>
          <ItpFormGroup
            name="exchange_rate_source"
            :label="'Exchange rate source'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="3"
            :labelAlign="labelAlign"
            :helpTooltip="'The currency exchange rate\'s provider.'|pgettext('ContractService|Tooltip')"
          >
            <ExchangeRateSourceSelector
              v-model="item.exchange_rate_source"
              :readonly="isServiceReadonly"
            >
            </ExchangeRateSourceSelector>
          </ItpFormGroup>
          <ItpFormGroup
            name="exchange_rate_date_rule"
            :label="'Exchange rate date rule'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'The date used to determine the exchange rate for billing purposes.'|pgettext('ContractService|Tooltip')"
          >
            <ExchangeRateDateRuleFields
              v-model="item.exchange_rate_date_rule"
              :readonly="isServiceReadonly"
            >
            </ExchangeRateDateRuleFields>
          </ItpFormGroup>
        </fieldset>
        <hr
          v-if="displayFee"
        >
        </hr>
        <ItpText
          strong
          :text="'Fee'|pgettext('ContractServiceEditor')"
          v-if="displayFee"
        >
        </ItpText>
        <ItpFormGroup
          name="fee_valid_from"
          :label="'Valid from'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="3"
          :labelAlign="labelAlign"
          :helpTooltip="'The start date of the fee.'|pgettext('ContractService|Tooltip')"
          v-if="displayFeeDates"
        >
          <ItpFormDatetime
            name="valid_from"
            v-model="feeItem.valid_from"
            required
          >
          </ItpFormDatetime>
        </ItpFormGroup>
        <ItpFormGroup
          name="fee_valid_to"
          :label="'Valid to'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="3"
          :labelAlign="labelAlign"
          :helpTooltip="'The end date of the fee. Set only if it\'s different from the service\'s end date.'|pgettext('ContractService|Tooltip')"
          v-if="displayFeeDates"
        >
          <ItpFormDatetime
            name="valid_to"
            v-model="feeItem.valid_to"
          >
          </ItpFormDatetime>
        </ItpFormGroup>
        <ItpFormGroup
          name="fee_valid_to"
          :label="'Amount'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="5"
          :labelAlign="labelAlign"
          contentClass="input-group"
          :helpTooltip="'The price per unit of the fee.'|pgettext('ContractService|Tooltip')"
          v-if="displayFee"
        >
          <ItpFormInput
            type="number"
            name="fee_amount"
            v-model="feeItem.amount"
            required
            class="col-9"
          >
          </ItpFormInput>
          <ItpFormSelect
            name="currency"
            v-model="feeItem.currency"
            :options="currencies"
            textField="code"
            valueField="code"
            required
            class="col-3"
          >
          </ItpFormSelect>
        </ItpFormGroup>
        <ItpFormGroup
          name="fee_unit"
          :label="'Invoice unit'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="2"
          :labelAlign="labelAlign"
          contentClass="input-group"
          :helpTooltip="'The unit used for billing.'|pgettext('ContractService|Tooltip')"
          v-if="displayFee"
        >
          <ItpFormInput
            name="fee_unit"
            v-model="feeItem.unit"
            required
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          name="fee_quantity"
          :label="'Quantity'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="2"
          :labelAlign="labelAlign"
          contentClass="input-group"
          :helpTooltip="'The quantity to bill for each period.'|pgettext('ContractService|Tooltip')"
          v-if="displayFee"
        >
          <ItpFormInput
            type="number"
            name="fee_quantity"
            v-model="feeItem.quantity"
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          name="fee_unit_of_quantity"
          :label="'Unit of quantity'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="2"
          :labelAlign="labelAlign"
          contentClass="input-group"
          :helpTooltip="'The unit of quantity - if different from the billing quantity.'|pgettext('ContractService|Tooltip')"
          v-if="displayFee"
        >
          <ItpFormInput
            name="fee_unit_of_quantity"
            v-model="feeItem.unit_of_quantity"
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          name="fee_inflation_indexed"
          :label="'Inflation indexed'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          :helpTooltip="'Indicates if the unit price should be automatically adjusted based on indexation rules.'|pgettext('ContractService|Tooltip')"
          v-if="displayFee"
        >
          <ItpFormCheckbox
            name="fee_inflation_indexed"
            v-model="feeItem.inflation_indexed"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          name="transaction_notes"
          :label="'Invoice notes'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          :helpTooltip="'Note to display on the invoice line.'|pgettext('ContractService|Tooltip')"
        >
          <TransactionNotesEditor
            v-model="feeItem.transaction_notes"
          >
          </TransactionNotesEditor>
        </ItpFormGroup>
        <ItpFormGroup
          name="fee_notes"
          :label="'Notes'|pgettext('ContractServiceFee')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          :helpTooltip="'Notes for internal use only.'|pgettext('ContractService|Tooltip')"
          v-if="displayFee"
        >
          <ItpFormTextarea
            name="fee_notes"
            v-model="feeItem.notes"
          >
          </ItpFormTextarea>
        </ItpFormGroup>
        <ItpButton
          :text="'Lock Service Fee'|pgettext('Button')"
          variant="light"
          icon="fa-lock"
          :spinning="actions.lockServiceFee.isRunning"
          v-if="mode === 'editServiceFee' && !feeItem.locked"
          @click.prevent.stop="evh_4704362798300200_clickPreventStop($event, {})"
        >
        </ItpButton>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Lock Service'|pgettext('Button')"
      variant="light"
      icon="fa-lock"
      :spinning="actions.lockService.isRunning"
      v-if="mode === 'editService' && !service.locked"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :text="'Delete Service'|pgettext('Button')"
      variant="danger"
      icon="fa-times"
      :spinning="actions.deleteService.isRunning"
      class="mr-auto"
      v-if="mode === 'editService' && isDeletable"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :text="'Delete Fee'|pgettext('Button')"
      variant="danger"
      icon="fa-times"
      :spinning="actions.deleteServiceFee.isRunning"
      class="mr-auto"
      v-if="mode === 'editServiceFee' && isDeletable"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :text="'Save'|pgettext('Button')"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
      v-if="isEditable"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1037450307673255_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ContractServiceEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getConfiguration(...args: any[]) {
    switch (this.mode) {

      case 'addService':
        return {
          isEditable: true,
          isDeletable: false,
          isServiceReadonly: false,
        };

      case 'editService':
        return {
          isEditable: !this.service.locked,
          isDeletable: !this.service.locked,
          isServiceReadonly: this.service.locked,
        };

      case 'addServiceFee':
        return {
          isEditable: true,
          isDeletable: true,
          isServiceReadonly: true,
          isServiceFeeReadonly: false
        };

      case 'editServiceFee':
        return {
          isEditable: !this.fee.locked,
          isDeletable: !this.fee.locked,
          isServiceReadonly: true,
          isServiceFeeReadonly: this.fee.locked
        };
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    type: Object,
  })
  service!: object;

  @Watch('service')
  onService(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("service")
  }

  @Prop({
    type: Object,
  })
  fee!: object;

  @Watch('fee')
  onFee(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("fee")
  }

  @Prop({
    required: true,
    type: String,
  })
  mode!: string;

  @Watch('mode')
  onMode(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("mode")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  labelAlign!: any;
  isEditable!: any;

  async $$load_isEditable() {
    return this.getConfiguration().isEditable
  }

  isDeletable!: any;

  async $$load_isDeletable() {
    return this.getConfiguration().isDeletable
  }

  isServiceReadonly!: any;

  async $$load_isServiceReadonly() {
    return this.getConfiguration().isServiceReadonly
  }

  isServiceFeeReadonly!: any;

  async $$load_isServiceFeeReadonly() {
    return this.getConfiguration().isServiceFeeReadonly
  }

  billingCategories!: any;

  async $$load_billingCategories() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } })
  }

  messages!: any;
  item!: any;

  async $$load_item() {
    return this.service || this.$fn.schemaDefaults('CreateContractService', {
      valid_from: this.contract.lifecycle.valid_from,  // $fn.today(),
      contract_id: this.contract.id
    })
  }

  feeItem!: any;

  async $$load_feeItem() {
    return this.fee ||
      this.$fn.schemaDefaults('CreateContractServiceFee', {
        unit: _.get(this.item, 'service.unit'),
        contract_id: this.contract.id,
        service_id: _.get(this.item, 'id'),
      })
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$fn.fetch('list_currency')
  }

  services!: any;

  async $$load_services() {
    return this.$fn.fetch('suggest_product', {
      parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
    }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]))
  }

  invoiceGroups!: any;

  async $$load_invoiceGroups() {
    return this.$fn.fetch('list_product_invoice_group')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_7307096920626688_multiple!: any;
  dataMembers = ['formId', 'labelAlign', 'isEditable', 'isDeletable', 'isServiceReadonly', 'isServiceFeeReadonly', 'billingCategories', 'messages', 'item', 'feeItem', 'currencies', 'services', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_7307096920626688_multiple'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        labelAlign: "right",
        isEditable: null,
        isDeletable: null,
        isServiceReadonly: null,
        isServiceFeeReadonly: null,
        billingCategories: null,
        messages: {
          addService: {
            title: this.$fn.pgettext("Contract", "Add Service"),
          }
          ,
          editService: {
            title: this.$fn.pgettext("Contract", "Edit Service"),
          }
          ,
          addServiceFee: {
            title: this.$fn.pgettext("Contract", "Add Service Fee"),
          }
          ,
          editServiceFee: {
            title: this.$fn.pgettext("Contract", "Edit Service Fee"),
          }
          ,
        }
        ,
        item: null,
        feeItem: null,
        currencies: null,
        services: null,
        invoiceGroups: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "lg",
        }
        ,
        b_7307096920626688_multiple: false,
      },
    }
  }

  get currentObjectType() {
    if (this.loaded) {

      return this.mode.indexOf('Fee') > -1 ? 'contract_service_fee' : 'contract_service'
    }
    return null;
  }

  get displayFee() {
    if (this.loaded) {

      return this.mode !== 'editService'
    }
    return null;
  }

  get displayFeeDates() {
    if (this.loaded) {

      return this.displayFee && this.mode !== 'addService'
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.messages[this.mode].title,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8826_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8826, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_8832_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_8832, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_8830_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_8830, alias=save
    return {
      objectType: this.currentObjectType,
      op: "upsert",
      data: this.mode === 'addService'
        ? _.extend({}, this.item, { fees: [_.extend(this.feeItem, { valid_from: this.item.valid_from, valid_to: this.item.valid_to })] })
        : (this.currentObjectType == 'contract_service' ? this.item : this.feeItem),
      options: {
        parameters: {
          rev: this.contract.revision_number,
        }
        ,
      }
      ,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_3054425420812800_setData_8834_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_3054425420812800_setData_8834, alias=undefined
    return {
      path: "item.name",
      value: $event.data.option.name,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_3054425420812800_setData_8836_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_3054425420812800_setData_8836, alias=undefined
    return {
      path: "item.service_id",
      value: $event.data.option.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_3054425420812800_setData_8838_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_3054425420812800_setData_8838, alias=undefined
    return {
      path: "feeItem.unit",
      value: $event.data.option.unit,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_3054425420812800_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3054425420812800_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_4704362798300200_closeModal_8842_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_4704362798300200_closeModal_8842, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_4704362798300200_request_8840_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4704362798300200_request_8840, alias=lockServiceFee
    return {
      operation: "update_contract_service_fee",
      data: {
        id: this.feeItem.id,
        etag: this.feeItem.etag,
        locked: true
      },
    }
  }

  async evh_4704362798300200_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4704362798300200_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeModal_8846_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1548630417156826_closeModal_8846, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1548630417156826_request_8844_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1548630417156826_request_8844, alias=lockService
    return {
      operation: "update_contract_service",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        locked: true
      },
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_8850_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_8850, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1419464017721962_request_8848_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1419464017721962_request_8848, alias=deleteService
    return {
      operation: "delete_contract_service",
      data: this.item,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2186679009640457_closeModal_8854_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2186679009640457_closeModal_8854, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_2186679009640457_request_8852_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2186679009640457_request_8852, alias=deleteServiceFee
    return {
      operation: "delete_contract_service_fee",
      data: this.feeItem,
    }
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_1037450307673255_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1037450307673255_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8826: actions.CloseModalAction;
    evh_7315092382398562_close_8825: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_8828: actions.CloseComponentAction;
    evh_2248226175642056_close_8827: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_8832: actions.CloseModalAction;
    evh_1040167445267876_success_8831: actions.EventHandlerImpl;
    act_1040167445267876_crud_8830: actions.CRUDAction;
    evh_1040167445267876_submit_8829: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_3054425420812800_setData_8834: actions.SetDataAction;
    evh_3054425420812800_optionSelected_8833: actions.EventHandlerImpl;
    act_3054425420812800_setData_8836: actions.SetDataAction;
    evh_3054425420812800_optionSelected_8835: actions.EventHandlerImpl;
    act_3054425420812800_setData_8838: actions.SetDataAction;
    evh_3054425420812800_optionSelected_8837: actions.EventHandlerImpl;
    evh_3054425420812800_optionSelected: actions.EventHandlerGroup;
    act_4704362798300200_closeModal_8842: actions.CloseModalAction;
    evh_4704362798300200_success_8841: actions.EventHandlerImpl;
    act_4704362798300200_request_8840: actions.RequestAction;
    evh_4704362798300200_clickPreventStop_8839: actions.EventHandlerImpl;
    evh_4704362798300200_clickPreventStop: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_8846: actions.CloseModalAction;
    evh_1548630417156826_success_8845: actions.EventHandlerImpl;
    act_1548630417156826_request_8844: actions.RequestAction;
    evh_1548630417156826_clickPreventStop_8843: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_8850: actions.CloseModalAction;
    evh_1419464017721962_success_8849: actions.EventHandlerImpl;
    act_1419464017721962_request_8848: actions.RequestAction;
    evh_1419464017721962_clickPreventStop_8847: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
    act_2186679009640457_closeModal_8854: actions.CloseModalAction;
    evh_2186679009640457_success_8853: actions.EventHandlerImpl;
    act_2186679009640457_request_8852: actions.RequestAction;
    evh_2186679009640457_clickPreventStop_8851: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
    act_1037450307673255_closeComponent_8856: actions.CloseComponentAction;
    evh_1037450307673255_clickPreventStop_8855: actions.EventHandlerImpl;
    evh_1037450307673255_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8826 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8826_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8825 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8826,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8825],
      }
    );
    const act_2248226175642056_closeComponent_8828 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8827 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_8828,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8827],
      }
    );
    const act_1040167445267876_closeModal_8832 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_8832_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8831 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_8832,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_8830 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_8830_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_8831],
      }
    );
    const evh_1040167445267876_submit_8829 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_8830,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8829],
      }
    );
    const act_3054425420812800_setData_8834 = new actions.SetDataAction(
      {
        actionArgs: this.act_3054425420812800_setData_8834_getActionArgs,
        events: [],
      }
    );
    const evh_3054425420812800_optionSelected_8833 = new actions.EventHandlerImpl(
      {
        action: act_3054425420812800_setData_8834,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_3054425420812800_setData_8836 = new actions.SetDataAction(
      {
        actionArgs: this.act_3054425420812800_setData_8836_getActionArgs,
        events: [],
      }
    );
    const evh_3054425420812800_optionSelected_8835 = new actions.EventHandlerImpl(
      {
        action: act_3054425420812800_setData_8836,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_3054425420812800_setData_8838 = new actions.SetDataAction(
      {
        actionArgs: this.act_3054425420812800_setData_8838_getActionArgs,
        events: [],
      }
    );
    const evh_3054425420812800_optionSelected_8837 = new actions.EventHandlerImpl(
      {
        action: act_3054425420812800_setData_8838,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const evh_3054425420812800_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_3054425420812800_optionSelected_8833, evh_3054425420812800_optionSelected_8835, evh_3054425420812800_optionSelected_8837],
      }
    );
    const act_4704362798300200_closeModal_8842 = new actions.CloseModalAction(
      {
        actionArgs: this.act_4704362798300200_closeModal_8842_getActionArgs,
        events: [],
      }
    );
    const evh_4704362798300200_success_8841 = new actions.EventHandlerImpl(
      {
        action: act_4704362798300200_closeModal_8842,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_4704362798300200_request_8840 = new actions.RequestAction(
      {
        actionArgs: this.act_4704362798300200_request_8840_getActionArgs,
        displayName: "lockServiceFee",
        events: [evh_4704362798300200_success_8841],
      }
    );
    const evh_4704362798300200_clickPreventStop_8839 = new actions.EventHandlerImpl(
      {
        action: act_4704362798300200_request_8840,
        event: "click.prevent.stop",
        displayName: "lockServiceFee",
      }
    );
    const evh_4704362798300200_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4704362798300200_clickPreventStop_8839],
      }
    );
    const act_1548630417156826_closeModal_8846 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1548630417156826_closeModal_8846_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_8845 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_8846,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1548630417156826_request_8844 = new actions.RequestAction(
      {
        actionArgs: this.act_1548630417156826_request_8844_getActionArgs,
        displayName: "lockService",
        events: [evh_1548630417156826_success_8845],
      }
    );
    const evh_1548630417156826_clickPreventStop_8843 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_request_8844,
        event: "click.prevent.stop",
        displayName: "lockService",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_8843],
      }
    );
    const act_1419464017721962_closeModal_8850 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_8850_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_success_8849 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_8850,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1419464017721962_request_8848 = new actions.RequestAction(
      {
        actionArgs: this.act_1419464017721962_request_8848_getActionArgs,
        displayName: "deleteService",
        events: [evh_1419464017721962_success_8849],
      }
    );
    const evh_1419464017721962_clickPreventStop_8847 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_request_8848,
        event: "click.prevent.stop",
        displayName: "deleteService",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_8847],
      }
    );
    const act_2186679009640457_closeModal_8854 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2186679009640457_closeModal_8854_getActionArgs,
        events: [],
      }
    );
    const evh_2186679009640457_success_8853 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeModal_8854,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_2186679009640457_request_8852 = new actions.RequestAction(
      {
        actionArgs: this.act_2186679009640457_request_8852_getActionArgs,
        displayName: "deleteServiceFee",
        events: [evh_2186679009640457_success_8853],
      }
    );
    const evh_2186679009640457_clickPreventStop_8851 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_request_8852,
        event: "click.prevent.stop",
        displayName: "deleteServiceFee",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_8851],
      }
    );
    const act_1037450307673255_closeComponent_8856 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1037450307673255_clickPreventStop_8855 = new actions.EventHandlerImpl(
      {
        action: act_1037450307673255_closeComponent_8856,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1037450307673255_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1037450307673255_clickPreventStop_8855],
      }
    );
    return {
      act_7315092382398562_closeModal_8826,
      evh_7315092382398562_close_8825,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_8828,
      evh_2248226175642056_close_8827,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_8832,
      evh_1040167445267876_success_8831,
      act_1040167445267876_crud_8830,
      evh_1040167445267876_submit_8829,
      evh_1040167445267876_submit,
      act_3054425420812800_setData_8834,
      evh_3054425420812800_optionSelected_8833,
      act_3054425420812800_setData_8836,
      evh_3054425420812800_optionSelected_8835,
      act_3054425420812800_setData_8838,
      evh_3054425420812800_optionSelected_8837,
      evh_3054425420812800_optionSelected,
      act_4704362798300200_closeModal_8842,
      evh_4704362798300200_success_8841,
      act_4704362798300200_request_8840,
      evh_4704362798300200_clickPreventStop_8839,
      evh_4704362798300200_clickPreventStop,
      act_1548630417156826_closeModal_8846,
      evh_1548630417156826_success_8845,
      act_1548630417156826_request_8844,
      evh_1548630417156826_clickPreventStop_8843,
      evh_1548630417156826_clickPreventStop,
      act_1419464017721962_closeModal_8850,
      evh_1419464017721962_success_8849,
      act_1419464017721962_request_8848,
      evh_1419464017721962_clickPreventStop_8847,
      evh_1419464017721962_clickPreventStop,
      act_2186679009640457_closeModal_8854,
      evh_2186679009640457_success_8853,
      act_2186679009640457_request_8852,
      evh_2186679009640457_clickPreventStop_8851,
      evh_2186679009640457_clickPreventStop,
      act_1037450307673255_closeComponent_8856,
      evh_1037450307673255_clickPreventStop_8855,
      evh_1037450307673255_clickPreventStop,
      save: act_1040167445267876_crud_8830,
      lockServiceFee: act_4704362798300200_request_8840,
      lockService: act_1548630417156826_request_8844,
      deleteService: act_1419464017721962_request_8848,
      deleteServiceFee: act_2186679009640457_request_8852,
    }
  }
}

Vue.component("ContractServiceEditor", ContractServiceEditor);

</script>